import { Component, Input } from "@angular/core";
import { CustomColumnComponent, SharedModule } from "@bb-vendure/admin-ui/core";

@Component({
  selector: "artist",
  imports: [SharedModule],
  styleUrl: "./artist-column.component.scss",
  templateUrl: "./artist-column.component.html",
  standalone: true,
})
export class ArtistColumnComponent implements CustomColumnComponent {
  @Input() rowItem: {
    customFields: {
      artist: any;
    };
  };
}
